import  { USER_LIBRARY, UPDATE_LIBRARY_ERROR, PUBLIC_LIBRARIES } from  '../actions/ActionTypes';
import api from '../api'
import { MESSAGE } from "../helpers/constants"
import { toast } from 'react-toastify';
export function fetchLibrary() {
    return function (dispatch) {
        api.get('libraries').then(async (response) => {
            if (response.status === "success") {
				let approvedLibraries = response.payload.filter(x=>x.status !== "PENDING");
                let pendingLibraries = response.payload.filter(x=>x.status === "PENDING");
                await dispatch({
                    type: USER_LIBRARY,
					data: response.payload,
					approvedLibraries,
					pendingLibraries
                });
            }
        });
    }
}

export function fetchPublicLibraries() {
    return function (dispatch) {
        api.get('all-libraries').then(async (response) => {
            if (response.status === "success") {
                await dispatch({
                    type: PUBLIC_LIBRARIES,
					data: response.payload
                });
            }
        });
    }
}


export function UpdateLibraryStatus(status,id){
	return function(dispatch){
		let data = {};
		data.status = status
		api.put("libraries/approval/"+id, data).then(async (response) => {
			if (response.status === "success") {
				dispatch(fetchLibrary())
			}
		})
	}
}

export function updateLibrary(router, data,id) {
	return function (dispatch) {
		let formData = new FormData();
	if(data.library_image !== null){
		formData.append('library_image', data.library_image);
	}

	

	formData.append('library_name', data.library_name);
	formData.append('address_line1', data.address_line1);
	formData.append('address_line2', data.address_line2);
	formData.append('city', data.city);
	formData.append('state', data.state);
	formData.append('country', data.country);
	formData.append('zipcode', data.zipcode);
	formData.append('interested_in_stem', data.interested_in_stem);
	formData.append('state_or_county', data.state_or_county);
	formData.append('website_url', data.website_url);
	formData.append('notes', data.notes);
	formData.append('library_email', data.library_email);
	formData.append('library_phone', data.library_phone);

	api.normalPut("libraries/"+id, formData).then(async (response) => {
		if (response.status === "success") {
			api.get('libraries').then((response) => {
				if (response.status === "success") {
					toast.success(MESSAGE.library_upadte, {
						position: toast.POSITION.BOTTOM_RIGHT
					});
					dispatch({
						type: USER_LIBRARY,
						data: response.payload
					});
				}
			});
			
		} else {
			toast.error(response.message, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
			await dispatch({
				type: UPDATE_LIBRARY_ERROR,
				data: response.message
			});
		}
	})
	router.setState({
        open: false,
     }); 
	}
}